import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ProceedingDetails from './ProceedingDetails/ProceedingDetails';
import ProceedingEvents from './ProceedingType/ProceedingTypes';
import Resources from './Resources';
import ParticipantList from './Party/PartyList';
import SubmissionListPage from '../pages/SubmissionListPage';
import ProceedingStatusPage from '../pages/ProceedingStatusPage';
import DataFiles from './DataFiles/DataFiles';
import ProceedingHeader from './ProceedingHeader';
import Appeals from './Appeals/Appeals';
import CostClaim from './CostClaim/CostClaim';
import { useIsAuthenticated } from '@azure/msal-react';

const { TabPane } = Tabs;

const TabContainer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();

  const queryParams = new URLSearchParams(location.search);
  const initialTabKey = queryParams.get('tab') || '1';
  const { proceedingId } = useParams<{ proceedingId: string }>();

  const [activeTabKey, setActiveTabKey] = useState(initialTabKey);

  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
    navigate(`${location.pathname}?tab=${key}`);
  };

  useEffect(() => {
    setActiveTabKey(initialTabKey);
  }, [initialTabKey]);

  return (
    <div style={{ padding: '20px' }}>
      <ProceedingHeader proceedingNumber={proceedingId} />
      <Tabs defaultActiveKey="1" type="card" onChange={handleTabChange} activeKey={activeTabKey}>
        <TabPane tab="Proceeding Details" key="1">
          <ProceedingDetails />
        </TabPane>
        <TabPane tab="Proceeding Types" key="2">
          <ProceedingEvents />
        </TabPane>
        <TabPane tab="Parties/Others" key="3">
          <ParticipantList />
        </TabPane>
        <TabPane tab="Submission Schedule" key="4">
          <SubmissionListPage />
        </TabPane>
        {isAuthenticated && (
          <TabPane tab="Proceeding Resources" key="5">
            <Resources />
          </TabPane>
        )}
        <TabPane tab="Exhibits" key="6">
          <DataFiles />
        </TabPane>
        {isAuthenticated && (
          <TabPane tab="Proceeding Status" key="7">
            <ProceedingStatusPage />
          </TabPane>
        )}
        {isAuthenticated && (
          <TabPane tab="Appeals" key="8">
            <Appeals />
          </TabPane>
        )}
        {isAuthenticated && (
          <TabPane tab="Cost Claim" key="9">
            <CostClaim />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default TabContainer;
